import { styled } from "@mui/material/styles";

export const Logo = styled(() => (
  <svg
    width="60"
    height="55"
    viewBox="0 0 60 55"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="52.0401"
      y="46.2356"
      width="16.8159"
      height="3.2"
      rx="1.6"
      transform="rotate(-127 52.0401 46.2356)"
      fill="#949494"
    />
    <rect
      x="32.3601"
      y="18.2356"
      width="16.8159"
      height="3.2"
      rx="1.6"
      transform="rotate(-127 32.3601 18.2356)"
      fill="#949494"
    />
    <rect
      x="3.52002"
      y="26.72"
      width="16.8159"
      height="3.2"
      rx="1.6"
      fill="#949494"
    />
    <g clip-path="url(#clip0_4_24)">
      <path
        d="M35.32 12.5599L36.52 12.8266L37.4933 13.1733L38.28 13.5733L38.88 13.9999L39.3333 14.4533L39.6667 14.9066L39.88 15.3466L40.0133 15.7466L40.0667 16.0933L40.0933 16.3599L40.08 16.5333V23.6533L40.0133 24.4933L39.84 25.2266L39.56 25.8399L39.2133 26.3466L38.8133 26.7599L38.3733 27.0933L37.9067 27.3466L37.44 27.5333L37 27.6666L36.6 27.7599L36.2533 27.8133L35.9733 27.8399H28.0133L27.0933 27.9066L26.3067 28.0933L25.64 28.3866L25.0933 28.7466L24.6533 29.1733L24.2933 29.6399L24.0267 30.1199L23.8267 30.6133L23.6933 31.0799L23.6 31.5066L23.5467 31.8666L23.52 32.1466V36.2266H20.5467L20.2667 36.1866L19.8933 36.0933L19.4667 35.9333L19 35.6933L18.52 35.3466L18.04 34.8666L17.5733 34.2533L17.1467 33.4666L16.7733 32.4933L16.4933 31.3199L16.3067 29.9199L16.24 28.2799L16.32 26.6533L16.5333 25.2666L16.8533 24.1066L17.28 23.1599L17.76 22.3999L18.2933 21.8133L18.8533 21.3733L19.4133 21.0533L19.9467 20.8399L20.4267 20.7066L20.8533 20.6399L21.1733 20.6266H21.3867L21.4667 20.6399H32.3467V19.5333H24.56L24.5467 15.8666L24.52 15.3733L24.5867 14.9199L24.7333 14.5066L24.96 14.1333L25.2933 13.7866L25.7067 13.4799L26.2133 13.2133L26.8 12.9733L27.48 12.7733L28.2533 12.6133L29.1067 12.4799L30.0533 12.3999L31.08 12.3466L32.2 12.3199L33.8933 12.3866L35.32 12.5599ZM26.92 15.1999L26.6133 15.6399L26.5067 16.1866L26.6133 16.7333L26.92 17.1866L27.36 17.4799L27.9067 17.5999L28.4533 17.4799L28.8933 17.1866L29.2 16.7333L29.3067 16.1866L29.2 15.6399L28.8933 15.1999L28.4533 14.9066L27.9067 14.7866L27.36 14.9066L26.92 15.1999ZM44.3733 20.4666L44.7467 20.5466L45.1733 20.7066L45.64 20.9466L46.12 21.3066L46.6 21.7733L47.0667 22.3999L47.4933 23.1866L47.8667 24.1599L48.1467 25.3333L48.3333 26.7199L48.4 28.3599L48.32 29.9999L48.1067 31.3866L47.7867 32.5333L47.36 33.4799L46.88 34.2399L46.3467 34.8399L45.7867 35.2799L45.2267 35.5999L44.6933 35.8133L44.2133 35.9333L43.7867 35.9999L43.4667 36.0266L43.2533 36.0133H32.2933V37.1066H40.08L40.0933 40.7866L40.12 41.2666L40.0533 41.7199L39.9067 42.1333L39.68 42.5199L39.3467 42.8533L38.9333 43.1733L38.4267 43.4399L37.84 43.6666L37.16 43.8666L36.3867 44.0399L35.5333 44.1599L34.5867 44.2533L33.56 44.3066L32.44 44.3199L30.7467 44.2666L29.32 44.0799L28.12 43.8133L27.1467 43.4799L26.36 43.0799L25.76 42.6399L25.3067 42.1866L24.9733 41.7333L24.76 41.2933L24.6267 40.8933L24.5733 40.5599L24.5467 40.2933L24.56 40.1199V32.9999L24.6267 32.1466L24.8 31.4266L25.08 30.8133L25.4267 30.3066L25.8267 29.8799L26.2667 29.5599L26.7333 29.2933L27.2 29.1066L27.64 28.9733L28.04 28.8933L28.3867 28.8399L28.6667 28.8133L28.84 28.7999H36.6267L37.5467 28.7333L38.3333 28.5466L39 28.2666L39.5467 27.8933L39.9867 27.4666L40.3467 26.9999L40.6133 26.5199L40.8133 26.0399L40.9467 25.5733L41.04 25.1466L41.0933 24.7733L41.12 24.4933V20.4133H43.9067L44.0933 20.4266L44.3733 20.4666ZM35.7467 39.4666L35.44 39.9066L35.3333 40.4533L35.44 40.9999L35.7467 41.4399L36.1867 41.7466L36.7333 41.8533L37.28 41.7466L37.72 41.4399L38.0267 40.9999L38.1333 40.4533L38.0267 39.9066L37.72 39.4666L37.28 39.1599L36.7333 39.0533L36.1867 39.1599L35.7467 39.4666Z"
        fill="#28B6DB"
      />
    </g>
    <rect
      x="44"
      y="4.31995"
      width="16"
      height="6.24"
      rx="3.12"
      fill="#949494"
    />
    <rect
      x="53.76"
      y="20.3199"
      width="16"
      height="6.24"
      rx="3.12"
      transform="rotate(-90 53.76 20.3199)"
      fill="#949494"
    />
    <rect
      x="21.76"
      y="54.72"
      width="16"
      height="6.24"
      rx="3.12"
      transform="rotate(-180 21.76 54.72)"
      fill="#949494"
    />
    <rect
      x="12"
      y="38.72"
      width="16"
      height="6.24"
      rx="3.12"
      transform="rotate(90 12 38.72)"
      fill="#949494"
    />
    <circle cx="24.24" cy="4.4" r="4.4" fill="#32D3F4" />
    <circle cx="4.4" cy="28.4" r="4.4" fill="#32D3F4" />
    <circle cx="52.72" cy="44.4" r="4.4" fill="#32D3F4" />
    <defs>
      <clipPath id="clip0_4_24">
        <rect
          width="32"
          height="32"
          fill="white"
          transform="translate(16.32 12.3199)"
        />
      </clipPath>
    </defs>
  </svg>
))``;
